import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlugFill } from 'react-bootstrap-icons';
import PrimaryButton from './PrimaryButton';

/** Persistent header CTA when no broker is linked — connect is deferred, never gated. */
export default function ConnectBrokerHeaderButton({ size = 'sm' }) {
  const navigate = useNavigate();
  return (
    <PrimaryButton
      title="Connect your broker"
      onClick={() => navigate('/onboarding')}
      variant="compact"
      size={size}
      style={{ height: 36, minHeight: 36, paddingTop: 0, paddingBottom: 0, fontSize: '0.8rem', flexShrink: 0 }}
    >
      <PlugFill size={14} />
      Connect Broker
    </PrimaryButton>
  );
}
